import { render, staticRenderFns } from "./adminCrmStats.vue?vue&type=template&id=33a59ceb&scoped=true&"
import script from "./adminCrmStats.vue?vue&type=script&lang=js&"
export * from "./adminCrmStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a59ceb",
  null
  
)

export default component.exports